import script from "./StyleOption.vue?vue&type=script&setup=true&lang=js"
export * from "./StyleOption.vue?vue&type=script&setup=true&lang=js"

import "./StyleOption.vue?vue&type=style&index=0&id=3b0b38f0&lang=scss"

const __exports__ = script;

export default __exports__